export default [
  {
    name: "Auto Accept",
    value: 'campaign-accept'
  },
  {
    name: "User Claim",
    value: 'campaign-claim'
  }
]



/** WEBPACK FOOTER **
 ** ./src/forms/options/method.js
 **/